
export enum RequestActionsConstant {
    AUTH = "R2D2x99FFfx",
    GET_SESSION = "B9OrwkbFnh",
    GET_NOTIFICATION = "iyG8O2XL5C",
    GET_NEWSFEED = "7kCXWTpXyR",
    GET_SEARCH = "FkCExTpXyRz",
    EVENT_LOG = "0hgkUQLJwA",
    GET_NEW_CONTENT_COUNT = "0Z1LA7qTdc"
}
